/**
 * This object is used to share the element rotation state between the element drag
 * layer and the rest of the app (specifically the DraggableElement).
 * The final element rotation state is internal state to the drag layer, however it's
 * required outside the drag layer so that the drop animation can complete the rotation
 * animation.
 *
 * A singleton is used because the state is simply shared & not required to force
 * re-renders, thus we don't need to hook into the redux store.
 */
const dropState = {
    animatingDrag: false,
    elementRotation: null,
    targetOffset: null,
    maxRotation: null,
    lastTimestamp: null,
    shadowIntensity: 0,
};

export const clearDropStateSingleton = () => {
    dropState.animatingDrag = false;
    dropState.elementRotation = null;
    dropState.targetOffset = null;
    dropState.maxRotation = null;
    dropState.lastTimestamp = null;
    dropState.shadowIntensity = 0;
};

export default dropState;
